// extracted by mini-css-extract-plugin
module.exports = {"root":"form-checkbox-module--root--RMTCO","check":"form-checkbox-module--check--2ADHk","checked":"form-checkbox-module--checked--1OtUm"};